const BASE = '/plus-websites';

export const CONTENT_TABS = {
  pages: 'pages',
  headerAndFooter: 'header-footer',
} as const;

export type ContentTab = (typeof CONTENT_TABS)[keyof typeof CONTENT_TABS];

// Every website sub-page carries the organisation (and website) id in the query string,
// so the way back up has to keep them — dropping them lands on the "no website yet" view.
function withParams(pathname: string, searchParams: URLSearchParams): string {
  const search = searchParams.toString();
  return search ? `${pathname}?${search}` : pathname;
}

/**
 * The website details screen — the tabbed shell where content, header & footer, theme
 * and admin settings live. This is the single level above any page or section screen.
 */
export function websiteDetailsPath(searchParams: URLSearchParams, contentTab?: ContentTab): string {
  const params = new URLSearchParams(searchParams);
  if (contentTab) params.set('contentTab', contentTab);
  return withParams(BASE, params);
}

/** The section list of a single page — the level above the page section editors. */
export function pageDetailsPath(pageId: string, searchParams: URLSearchParams): string {
  return withParams(`${BASE}/pages/${pageId}`, new URLSearchParams(searchParams));
}

/**
 * The full-screen preview of a single page, opened in a new tab. The preview route resolves the
 * page from all three ids, so they travel together rather than being rebuilt per call site.
 */
export function pagePreviewPath(params: {
  organisationId: string;
  websiteId: string;
  pageId: string;
}): string {
  return `${BASE}/preview?${new URLSearchParams(params)}`;
}
